module.exports = __webpack_public_path__ + "static/media/image6.32d68b74.jpg";